import "./styles.css";

const termPage = () => {
  return (
    <div class="about-section">
      {/* <h1>Syarat & Ketentuan</h1> */}
      <h4>Selamat Datang di Aplikasi Diary Muslim! </h4>
      <p>Saudara-saudara Muslim yang Kami Cintai</p>
      <p class="line-space">
        Misi kami adalah menghubungkan semua saudara Muslim di dunia dengan
        memberi kemudahan membangun komunitas agar mereka menjadi lebih mudah
        saling mengingatkan, merutinkan membaca, mendengarkan dan berbagi
        motivasi dan inspirasi yang bersumber dari Al-Quran.
      </p>
      <span class="span-bold">1. PENGANTAR</span>
      <p>
        Dalam Syarat & Ketentuan ini, memiliki beberapa definisi sebagai
        berikut:
      </p>
      <p>
        "Nama Pengguna" mengacu pada Nama atau kode unik identifikasi login yang
        mengidentifikasi Anda.
      </p>
      <p>
        "Kata Sandi" mengacu pada kata sandi yang sah yang Anda gunakan bersama
        dengan Nama Pengguna untuk mengakses dan menggunakan Aplikasi
      </p>
      <p>"DMapp" adalah aplikasi seluler, Aplikasi DiaryMuslim; </p>
      <p>
        "Perangkat" adalah perangkat seluler tempat Anda menjalankan Aplikasi;
      </p>
      <p>
        "Layanan" adalah layanan, informasi, fungsi, dan fitur yang disediakan
        untuk Anda melalui Aplikasi;{" "}
      </p>
      <p>
        "Materi Pengguna" berarti segala informasi, teks, dan / atau materi lain
        yang Anda kirimkan untuk dimasukkan dan / atau diposkan melalui Aplikasi
        dan / atau Layanan;
      </p>
      <p>
        Ketika Anda sudah memiliki akun DiaryMuslim, kami dapat mengumpulkan,
        mengolah, mengungkapkan dan menggunakan jenis-jenis informasi pribadi
        sehubungan dengan perangkat dan pengaturan Aplikasi Anda, yang termasuk
        namun tidak terbatas pada:
      </p>
      <span class="span-bold">2. HAK DAN BATASAN</span>
      <p>
        <span class="span-bold">2.1 LISENSI UNTUK MENGGUNAKAN APLIKASI</span>
      </p>
      <p>
        <span class="span-bold">2.1.1</span> Aplikasi ini adalah milik DMI dan
        tidak boleh digunakan diluar dengan ketentuan yang tercantum di sini.
        Jika Anda menyetujui Syarat & Ketentuan ini DMI memberikan kepada Anda
        hak pribadi, terbatas, tidak eksklusif, tidak dapat dipindahtangankan,
        hanya untuk penggunaan pribadi dan non-komersial dan selalu tunduk pada
        Syarat & Ketentuan ini, untuk tujuan mengakses dan menggunakan Layanan.
      </p>
      <p>
        <span class="span-bold">2.1.2 DMI</span> memiliki semua hak yang tidak
        diberikan di sini.
      </p>
      <p>
        <span class="span-bold">2.1.3</span> Anda tidak boleh dalam kondisi apa
        pun: (i) menyalin, menjual, mendistribusikan, mentransmisikan,
        menampilkan kepada publik, menyewakan, mengekspor, menerbitkan, atau
        mereproduksi Aplikasi atau bagian apa pun daripadanya dalam bentuk apa
        pun dengan cara apa pun; dan / atau (ii) menyesuaikan, memodifikasi,
        mendekompilasi, membongkar, dan / atau merekayasa balik Aplikasi atau
        bagian apa pun daripadanya.
      </p>
      <p>
        <span class="span-bold">2.1.4</span> Segala pelanggaran terhadap
        persyaratan atau pembatasan dalam Syarat & Ketentuan ini akan
        mengakibatkan penghentian segera dan otomatis semua hak dan lisensi yang
        diberikan di bawah ini.
      </p>
      <p>
        <span class="span-bold">2.2 PENGGUNAAN LAYANAN</span>
      </p>
      <p>
        <span class="span-bold">2.2.1</span> Anda harus (i) mematuhi semua hukum
        dan peraturan yang berlaku dalam penggunaan Aplikasi dan Layanan oleh
        Anda; (ii) tidak menyamar sebagai orang atau entitas apa pun atau secara
        salah menyatakan atau salah menggambarkan afiliasi Anda dengan orang
        atau entitas mana pun; (iii) tidak mengirim, mendistribusikan, atau
        mengunggah, dengan cara apa pun, data atau materi yang mengandung virus,
        kode berbahaya atau komponen berbahaya yang dapat mengganggu atau
        merusak operasi komputer atau perangkat lain; dan (iv) tidak memposting,
        mempromosikan, atau mentransmisikan melalui Aplikasi dan / atau Layanan
        setiap hal yang melanggar hukum, melecehkan, memfitnah, berbahaya,
        vulgar, cabul atau materi yang tidak menyenangkan dari jenis atau sifat
        apa pun.
      </p>
      <p>
        <span class="span-bold">2.3 PEMBATASAN HAK</span>
      </p>
      <p>
        <span class="span-bold">2.3.1 DMI</span> dapat dari waktu ke waktu tanpa
        memberikan alasan atau pemberitahuan sebelumnya, memutakhirkan,
        memodifikasi, mengubah, menangguhkan, menghentikan penyediaan atau
        menghapus, baik secara keseluruhan atau sebagian, Aplikasi dan / atau
        Layanan dan tidak akan bertanggung jawab jika setiap peningkatan,
        modifikasi, penangguhan atau perubahan seperti itu mencegah Anda
        mengakses Aplikasi dan / atau Layanan atau bagian daripadanya. Informasi
        dan / atau materi lain yang disediakan melalui Aplikasi atau Layanan
        dapat dimodifikasi, dihapus atau diganti dari waktu ke waktu dan kapan
        saja berdasarkan kebijaksanaan mutlak <span class="span-bold">DMI</span>
      </p>
      <p>
        <span class="span-bold">2.3.2 DMI</span> berhak, tetapi tidak
        berkewajiban untuk: (i) memantau, menyaring, atau mengendalikan
        aktivitas, konten, atau materi apapun yang disediakan melalui Aplikasi
        atau Layanan. DMI dapat menyelidiki setiap pelanggaran terhadap Syarat &
        Ketentuan ini dan dapat mengambil tindakan apa pun yang dianggap perlu;
        (ii) menghapus, memblokir, menolak, atau memindahkan Materi Pengguna apa
        pun yang tersedia melalui Aplikasi atau Layanan; (iii) untuk mencegah
        atau membatasi akses pengguna apa pun ke Aplikasi atau Layanan; dan /
        atau (iv) melaporkan kegiatan yang diduga melanggar hukum, undang-undang
        atau peraturan apa pun yang berlaku kepada pihak yang berwenang dan
        untuk bekerja sama dengan pihak berwenang tersebut.
      </p>
      <span class="span-bold">3. PENOLAKAN</span>
      <p>
        <span class="span-bold">3.1 DMI</span> tidak berkewajiban untuk memantau
        atau meninjau pesan, posting, transmisi, dan sejenisnya di atau dapat
        diakses melalui Aplikasi dan / atau Layanan, dan tidak bertanggung jawab
        atau berkewajiban yang timbul dari konten atau yang diakses melalui
        DMapp dan / atau Layanan untuk setiap kesalahan, pencemaran nama baik,
        fitnah, kelalaian, kepalsuan, kecabulan, pornografi, kata-kata kotor,
        ketidaktepatan atau materi atau konten yang tidak pantas lainnya pada
        atau dapat diakses melalui Aplikasi dan / atau Layanan.
      </p>
      <span class="span-bold">4. SANGGAHAN DAN BATASAN TANGGUNG JAWAB</span>
      <p>
        <span class="span-bold">4.1 TANPA JAMINAN</span>
      </p>
      <p>
        <span class="span-bold">4.1.1</span> Aplikasi dan Layanan dan semua
        informasi, bahan, layanan, dan fungsi yang terkandung di dalamnya
        termasuk, perangkat lunak, program, data, basis data, teks, grafik,
        audio, , tautan atau materi lainnya, disediakan "sebagaimana adanya
        ”Dan“ sebagaimana tersedia ”. TIDAK ADA JAMINAN APA PUN, TERSIRAT,
        TERSURAT ATAU PERNYATAAN, TERMASUK TIDAK TERBATAS PADA JAMINAN JUDUL,
        KETERLAMBATAN HAK-HAK PIHAK KETIGA, KEMAMPUAN, KUALITAS KEPUASAN,
        KESESUAIAN UNTUK TUJUAN DAN KEBEBASAN TERTENTU DARI VIRUS KOMPUTER ATAU
        BERBAGAI LAINNYA, KODE MENGHANCURKAN ATAU MERUSAK, PERANTARA, PROGRAM
        ATAU MAKRO, DIBERIKAN SEHUBUNGAN DENGAN APLIKASI ATAU LAYANAN, ATAU
        INFORMASI DAN MATERI YANG DIBERIKAN MELALUI APLIKASI ATAU LAYANAN. Tanpa
        mengurangi sifat umum dari hal tersebut di atas, DMI tidak menjamin: (i)
        keakuratan, ketepatan waktu, kecukupan atau kelengkapan informasi,
        materi, layanan dan / atau fungsi yang disediakan melalui Aplikasi dan /
        atau Layanan; (ii) bahwa penggunaan dan / atau akses Anda ke Aplikasi,
        Layanan atau informasi apa pun atau materi apa pun yang disediakan
        melalui Aplikasi atau Layanan, atau pengoperasian Aplikasi, tidak akan
        terganggu, aman atau bebas dari kesalahan atau kelalaian atau bahwa
        setiap cacat yang teridentifikasi akan diperbaiki; (iii) bahwa Aplikasi,
        Layanan, atau informasi atau materi apa pun yang disediakan melalui
        Aplikasi atau Layanan akan memenuhi persyaratan Anda atau bebas dari
        virus atau kode, perantara, program, atau makro yang destruktif. dan
        (iv) bahwa penggunaan Aplikasi dan / atau materi yang ditampilkan pada
        Aplikasi dan / atau Layanan oleh Anda tidak melanggar hak-hak dari pihak
        ketiga.
      </p>
      <p>
        <span class="span-bold">4.1.2</span> Selain itu, DMI tidak memberikan
        jaminan mengenai aplikasi, produk, atau layanan apa pun yang mungkin
        atau yang diperoleh, atau transaksi apa pun yang dilakukan, melalui
        Aplikasi atau Layanan.
      </p>
      <p>
        <span class="span-bold">4.1.3</span> Anda mengakui dan setuju bahwa DMI
        tidak menjamin keamanan dari setiap informasi yang dikirimkan oleh atau
        kepada Anda menggunakan Aplikasi atau Layanan dan dengan ini Anda
        menerima risiko bahwa setiap informasi yang dikirim atau diterima
        menggunakan Aplikasi atau Layanan dapat diakses oleh pihak ketiga yang
        tidak sah dan / atau diungkapkan oleh DMI dan oleh pejabat, karyawan,
        atau perantaranya kepada pihak ketiga yang mengaku sebagai Anda atau
        mengaku bertindak di bawah wewenang Anda.
      </p>
      <p>
        <span class="span-bold">4.1.4</span> Anda tidak akan memegang DMI atau
        pejabatnya, karyawan atau agennya yang bertanggung jawab atau
        berkewajiban, dalam kontrak, gugatan (termasuk kelalaian atau
        pelanggaran tugas berdasarkan undang-undang), ekuitas atau sebaliknya,
        untuk pengaksesan atau pengungkapan untuk segala kerusakan, kerugian,
        pengeluaran atau biaya (baik langsung atau tidak langsung, atau apakah
        dapat diperkirakan atau tidak) diderita atau ditanggung oleh Anda
        sebagai akibat dari akses atau pengungkapan tersebut.
      </p>
      <span class="span-bold">5. MATERI PENGGUNA</span>
      <p>
        <span class="span-bold">5.1</span> Anda tidak akan mengungkapkan detail
        kontak Anda kepada Pengguna lain melalui Aplikasi dan / atau Layanan dan
        akan mematuhi instruksi atau panduan apa pun yang dapat dipublikasikan
        atau disediakan oleh DMI dari waktu ke waktu.
      </p>
      <p>
        <span class="span-bold">5.2 DMI</span> tidak mendukung atau bertanggung
        jawab atas isi transmisi atau komunikasi Anda melalui Aplikasi dan /
        atau Layanan dan Anda sepenuhnya bertanggung jawab karenanya. Anda
        menjamin dan menyatakan bahwa Anda memiliki hak dan wewenang untuk
        menyerahkan Materi Pengguna Anda dan bahwa Materi Pengguna Anda tidak
        melanggar hak kekayaan intelektual atau hak lain dari pihak ketiga mana
        pun. Dengan ini Anda memberikan DMI lisensi non-eksklusif, bebas royalti
        di seluruh dunia, dan hak yang tidak dapat dibatalkan untuk menyediakan,
        mentransmisikan, mendistribusikan atau menggunakan (yang akan mencakup
        tanpa batasan, hak untuk menyalin, mereproduksi dan / atau
        mempublikasikan ) Materi Pengguna sehubungan dengan ketentuan Layanan
        kepada Anda untuk tujuan yang telah Anda perintahkan atau minta.
      </p>
      <span class="span-bold">6. PRIVASI DATA DAN KERAHASIAAN</span>
      <p>
        <span class="span-bold">6.1</span> Anda setuju bahwa semua informasi dan
        / atau keterangan yang dikirim atau disampaikan oleh Anda melalui
        Aplikasi atau Layanan adalah non-rahasia dan non-kepemilikan kecuali
        dinyatakan sebaliknya oleh Anda dan dapat dikumpulkan, digunakan dan
        diungkapkan oleh DMI sesuai dengan Kebijakan Privasi DMI, sebagaimana
        dapat diperbarui dan / atau diubah oleh DMI dari waktu ke waktu.
      </p>
      <span class="span-bold">7. BATASAN TANGGUNG JAWAB</span>
      <p>
        <span class="span-bold">7.1 DMI</span> tidak akan dalam keadaan apa pun
        atau dengan alasan apa pun tidak bertanggung jawab, bahkan jika DMI
        telah diberitahu tentang kemungkinan kerusakan, kehilangan atau
        pengeluaran tersebut, untuk segala kerusakan, kehilangan atau
        pengeluaran, termasuk kerusakan langsung, tidak langsung, khusus, atau
        konsekuensial, atau kerugian ekonomi, yang timbul dari atau sehubungan
        dengan (i) setiap akses, penggunaan atau ketidakmampuan untuk mengakses
        atau menggunakan Aplikasi atau Layanan; (ii) kegagalan sistem, server
        atau koneksi, kesalahan, kelalaian, gangguan, keterlambatan transmisi,
        virus komputer atau kode berbahaya, program perantara atau makro; (iii)
        segala penggunaan atau akses ke situs web atau halaman web lain apa pun
        yang disediakan melalui Aplikasi atau Layanan; (iv) segala layanan,
        produk, informasi, data, perangkat lunak, atau materi lain yang
        diperoleh atau diunduh dari Aplikasi atau Layanan atau dari situs web
        atau halaman web lain apa pun yang disediakan melalui Aplikasi atau
        Layanan atau dari pihak lain yang dirujuk oleh atau melalui penggunaan
        Aplikasi atau Layanan; atau (v) penggunaan atau penyalahgunaan Aplikasi
        atau Layanan Anda. Dalam hal apa pun, DMI tidak akan bertanggung jawab
        kepada Anda, atau pihak lain untuk: (a) jumlah yang jatuh tempo dari
        pengguna DMapp atau Layanan lain sehubungan dengan pembelian produk /
        layanan apa pun; (B) kerusakan yang timbul sehubungan dengan pengunduhan
        atau instalasi, atau ketidakmampuan untuk mengunduh atau menginstal
        Aplikasi, oleh Anda atau pihak ketiga lainnya; dan / atau (c) pajak
        penjualan, bea cukai dan / atau impor atau ekspor.
      </p>
      <span class="span-bold">8. GANTI RUGI</span>
      <p>
        <span class="span-bold">8.1</span> Anda akan mengganti kerugian dan
        membebaskan DMI dari dan terhadap setiap dan semua klaim, tindakan,
        proses, tuntutan, kerugian, kerusakan, penyelesaian, hukuman, denda,
        biaya atau pengeluaran (termasuk biaya dan pengeluaran pengacara dan
        klien ( legal atau lainnya)), yang DMI dapat pertahankan atau timbulkan,
        langsung atau tidak langsung, dengan alasan DMI telah menyediakan
        Aplikasi dan / atau Layanan kepada Anda atau telah memasuki Syarat &
        Ketentuan ini dengan Anda atau penegakan DMI. dan / atau hak-hak DMI
        berdasarkan Syarat & Ketentuan ini yang bertindak berdasarkan instruksi
        yang mungkin Anda berikan sehubungan dengan Aplikasi atau Layanan atau
        kelalaian, penipuan dan / atau pelanggaran di pihak Anda atau
        pelanggaran terhadap Syarat & Ketentuan ini.
      </p>
      <p>
        <span class="span-bold">8.2</span> Anda akan bekerja sama sepenuhnya
        dalam membela tuduhan atau tuntutan hukum pihak ketiga. DMI berhak untuk
        mengambil kendali dan pembelaan eksklusif atas masalah ganti rugi apa
        pun berdasarkan Pasal 8 ini.
      </p>
      <span class="span-bold">9. KEKAYAAN INTELEKTUAL</span>
      <p>
        <span class="span-bold">9.1</span> Semua hak cipta dan kekayaan
        intelektual lainnya serta hak kepemilikan dalam konten, termasuk tetapi
        tidak terbatas pada teks, perangkat lunak, kode, skrip, halaman web,
        grafik, antarmuka pengguna grafis, formulir, diagram, atau materi lain
        yang terkandung dalam Aplikasi atau Layanan ("Konten") milik DMI atau
        pemberi lisensinya kecuali dinyatakan lain.
      </p>
      <p>
        <span class="span-bold">9.2</span> Anda dapat mengakses materi yang
        ditampilkan pada Aplikasi atau melalui Layanan untuk penggunaan
        non-komersial Anda hanya asalkan Anda juga mempertahankan semua hak
        cipta dan pemberitahuan hak milik lainnya yang terkandung pada materi.
        Namun, Anda tidak boleh menyalin, mereproduksi, mendistribusikan,
        memodifikasi, mengirimkan, menggunakan kembali, memposting ulang, atau
        menggunakan Konten untuk tujuan publik atau komersial tanpa izin
        tertulis sebelumnya dari DMI. Merek dagang, logo, dan merek layanan
        (secara kolektif disebut "Merek Dagang") yang ditampilkan pada Aplikasi
        adalah Merek Dagang terdaftar dan tidak terdaftar dari DMI atau jika
        ada, pemilik pihak ketiga lainnya. Tidak ada hak atau lisensi yang
        diberikan kepada pihak mana pun yang mengakses Aplikasi atau Layanan
        untuk mengunduh, mereproduksi, atau menggunakan Merek Dagang tersebut.
      </p>
      <span class="span-bold">10. SISTEM PIHAK KETIGA</span>
      <p>
        <span class="span-bold">10.1</span> Bagian Layanan hanya dapat diakses
        dan / atau digunakan saat masuk ke sistem pihak ketiga seperti Facebook,
        Apple atau Google. Setiap penggunaan atau akses ke bagian-bagian Layanan
        tersebut dan informasi, data, instruksi atau komunikasi ("Komunikasi")
        apa pun yang dapat dirujuk ke akun Anda dengan sistem pihak ketiga
        tersebut (apakah akses, penggunaan atau Komunikasi tersebut diotorisasi
        oleh Anda atau tidak) harus dianggap sebagai (a) penggunaan atau akses
        Layanan oleh Anda dan / atau (b) Komunikasi yang dikirimkan dan
        dikeluarkan secara sah oleh Anda. Anda akan terikat oleh akses,
        penggunaan, dan / atau Komunikasi apa pun yang dapat dirujuk ke akun
        Anda dengan sistem pihak ketiga tersebut, dan Anda setuju bahwa DMI
        berhak (tetapi tidak berkewajiban) untuk bertindak, bergantung pada dan
        / atau membuat Anda sepenuhnya bertanggung jawab sehubungan dengan hal
        tersebut seolah-olah hal yang sama dilakukan atau dikirimkan oleh Anda.
      </p>
      <p>
        <span class="span-bold">10.2</span> Dalam keadaan apa pun tidak dapat
        ditafsirkan bahwa, dalam hal akses Anda ke dan penggunaan sistem
        (termasuk sistem pengiriman pesan), aplikasi, layanan, konten, bahan,
        produk atau program dari pihak ketiga mana pun, DMI adalah pihak dalam
        transaksi apa pun, jika ada, antara Anda dan pihak ketiga tersebut atau
        yang DMI mendukung, mensponsori, mensertifikasi, atau terlibat dalam
        penyediaan layanan, produk, aplikasi atau program tersebut yang dapat
        diakses melalui Aplikasi atau Layanan. DMI tidak akan bertanggung jawab
        dengan cara apa pun atas akses Anda ke dan penggunaan sistem pihak
        ketiga (termasuk sistem pengiriman pesan) atau untuk setiap produk yang
        diperoleh dan / atau dibeli dari atau layanan yang diberikan oleh pihak
        ketiga mana pun yang harus menjadi tanggung jawab Anda atau tanggung
        jawab pihak ketiga terkait.
      </p>
      <p>
        <span class="span-bold">10.3</span> Anda mengakui dan setuju bahwa Anda
        akan bertanggung jawab sepenuhnya atas akses atau penggunaan sistem
        pihak ketiga (termasuk sistem pengiriman pesan pihak ketiga), aplikasi,
        layanan, konten, materi, produk atau program melalui DMapp atau Layanan.
        Jika Anda mengakses atau menggunakan sistem pihak ketiga mana pun
        (termasuk sistem pengiriman pesan pihak ketiga mana pun) atau aplikasi,
        layanan, konten, materi, produk atau program dari pihak ketiga mana pun,
        melalui Aplikasi atau Layanan, Anda harus mematuhi syarat dan ketentuan
        yang relevan untuk akses atau penggunaan sistem, aplikasi, layanan,
        konten, materi, produk, atau program pihak ketiga tersebut dan
        bertanggung jawab atas pendaftaran dan penggunaan nama pengguna atau
        kata sandi apa pun yang diperlukan untuk menghubungkannya. Khususnya,
        jika akses dan penggunaan sistem pihak ketiga (termasuk sistem
        pengiriman pesan pihak ketiga), aplikasi, layanan, konten, materi,
        produk atau program melalui Aplikasi atau Layanan dilarang (baik secara
        penuh atau sebagian) oleh pihak ketiga tersebut syarat dan ketentuan
        pihak, harap hentikan akses dan penggunaan tersebut sesegera mungkin
        setelah mengetahui atau menerima pemberitahuan tentang larangan tersebut
        dari pihak ketiga terkait. DMI tidak dapat dan tidak tahu atau tidak
        menjamin bahwa Anda menggunakan Aplikasi atau Layanan untuk mengakses
        atau menggunakan sistem pihak ketiga (termasuk sistem pengiriman pesan
        pihak ketiga) atau aplikasi, layanan, konten, bahan, produk atau program
        dari pihak ketiga mana pun adalah diizinkan atau dalam kepatuhan,
        sepenuhnya atau tidak, dengan syarat dan ketentuan pihak ketiga yang
        berlaku. Dengan demikian, Anda tidak akan memiliki hak atau klaim apa
        pun, dan dengan ini melepaskan hak apa pun yang Anda miliki (jika ada),
        terhadap DMI sehubungan dengan pelanggaran atau kegagalan untuk mematuhi
        syarat dan ketentuan pihak ketiga terkait sehubungan dengan akses Anda
        ke dan / atau penggunaan sistem pihak ketiga tersebut (termasuk sistem
        pengiriman pesan pihak ketiga), aplikasi, layanan, konten, bahan, produk
        atau program melalui Aplikasi atau Layanan. Anda memberi wewenang kepada
        DMI untuk mengakses sistem pihak ketiga (termasuk sistem pengiriman
        pesan pihak ketiga), aplikasi, layanan, konten, bahan, produk atau
        program yang telah Anda tetapkan, untuk mengambil konten atau informasi
        yang diminta oleh Anda atau untuk memproses atau mengakses fungsiatas
        permintaan anda. Anda dengan ini menunjuk DMI sebagai agen Anda untuk
        tujuan tersebut di atas. Selain itu, setiap kali Anda mengirimkan nama
        pengguna atau kata sandi Anda untuk mengakses atau menggunakan sistem,
        aplikasi, layanan, konten, materi, produk atau program pihak ketiga yang
        Anda tunjuk, Anda akan dianggap telah memberi wewenang kepada DMI untuk
        memproses permintaan Anda dan gunakan informasi yang dikirimkan oleh
        Anda.
      </p>
      <span class="span-bold">11. PENGHENTIAN</span>
      <p>
        <span class="span-bold">11.1 DMI</span>, atas kebijakannya sendiri,
        dapat dengan segera setelah memberi Anda pemberitahuan dalam cara yang
        ditentukan dalam Pasal 13 di bawah ini, mengakhiri hak Anda untuk
        mengakses dan menggunakan Aplikasi dan / atau Layanan dan / atau
        membatalkan Nama Pengguna dan Kata Sandi Anda dan dapat melarang akses
        ke Aplikasi (atau bagiannya) dan / atau Layanan (atau bagiannya) dengan
        alasan apa pun, termasuk tanpa batasan, pelanggaran terhadap Syarat &
        Ketentuan ini.
      </p>
      <p>
        <span class="span-bold">11.2</span> Setelah pengakhiran Syarat &
        Ketentuan ini dengan alasan apa pun, semua hak dan / atau lisensi yang
        diberikan kepada Anda berdasarkan Syarat & Ketentuan ini akan segera
        berhenti dan berakhir dan Anda akan segera menghentikan akses dan
        penggunaan Aplikasi dan Layanan dengan cara apa pun.
      </p>
      <span class="span-bold">12. PERUBAHAN KETENTUAN PENGGUNAAN</span>
      <p>
        <span class="span-bold">12.1 DMI</span> dapat memberlakukan syarat dan
        ketentuan lebih lanjut tersebut dan membuat amandemen terhadap Syarat &
        Ketentuan ini karena DMI mungkin menurut kebijakannya cocok dari waktu
        ke waktu (termasuk syarat atau amandemen yang memungkinkan DMI untuk
        membebankan atau merevisi biaya untuk penggunaan Aplikasi dan / atau
        Layanan). DMI akan memberi tahu Anda tentang perubahan tersebut dengan
        memposting perubahan tersebut di DMapp atau metode pemberitahuan lainnya
        yang mungkin ditunjuk oleh DMI (seperti melalui email atau bentuk
        komunikasi elektronik lainnya), yang Anda setujui dengan pemberitahuan
        yang cukup untuk keperluan kasus ini. Jika Anda tidak setuju untuk
        terikat oleh amandemen, Anda harus segera menghentikan semua akses dan /
        atau penggunaan Aplikasi dan Layanan. Anda selanjutnya setuju bahwa jika
        Anda terus menggunakan dan / atau mengakses Aplikasi dan / atau Layanan
        setelah diberitahukan tentang perubahan terhadap Syarat & Ketentuan ini,
        penggunaan dan / atau akses tersebut akan merupakan suatu persetujuan:
        (i) pengakuan oleh Anda tentang hal-hal ini. Syarat & Ketentuan dan
        perubahannya; dan (ii) persetujuan oleh Anda untuk mematuhi dan terikat
        oleh Syarat & Ketentuan ini dan perubahannya.
      </p>
      <span class="span-bold">13. PEMBERITAHUAN</span>
      <p>
        <span class="span-bold">13.1</span> Setiap pemberitahuan atau komunikasi
        lain sehubungan dengan Syarat & Ketentuan ini dapat diberikan secara
        elektronik jika dikirim ke alamat maka yang terakhir diberitahukan oleh
        penerima kepada pengirim. Apabila pemberitahuan atau komunikasi
        diberikan oleh DMI kepada Anda secara elektronik, itu akan dianggap
        telah diterima pada saat pengiriman (dan laporan pengiriman yang
        diterima oleh DMI akan menjadi bukti pengiriman yang meyakinkan meskipun
        komunikasi tersebut tidak dibuka oleh Anda) dan jika diberikan kepada
        DMI secara elektronik, itu akan dianggap telah diterima setelah dibuka
        oleh <span class="span-bold">DMI</span>
      </p>
      <span class="span-bold">14. FORCE MAJEURE</span>
      <p>
        <span class="span-bold">14.1 DMI</span> tidak akan bertanggung jawab
        atas segala non-kinerja, kesalahan, gangguan atau keterlambatan dalam
        pelaksanaan kewajibannya atau dalam operasi Aplikasi atau Layanan, atau
        untuk segala ketidakakuratan, tidak dapat diandalkan atau
        ketidaksesuaian dari konten yang disediakan melalui Aplikasi atau
        Layanan, secara keseluruhan atau sebagian, secara langsung atau tidak
        langsung karena suatu peristiwa atau kegagalan yang berada di luar
        kendali wajar DMI (termasuk tindakan Tuhan, bencana alam, epidemi,
        tindakan perang atau terorisme, tindakan pemerintah atau otoritas apa
        pun, kegagalan daya, tindakan, atau wanprestasi dari operator atau
        operator jaringan telekomunikasi atau tindakan pihak yang tidak
        bertanggung jawab atas DMI
      </p>
    </div>
  );
};

export default termPage;
